module.exports = __webpack_public_path__ + "static/img/picture2.8a76433.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/swipe/picture2.jpg
// module id = CHfd
// module chunks = 0